export default __webpack_public_path__ + "static/media/DownloadGrey.5bfd2e7e.svg";